import { render, staticRenderFns } from "./Word.vue?vue&type=template&id=f3303484&scoped=true&"
import script from "./Word.vue?vue&type=script&lang=js&"
export * from "./Word.vue?vue&type=script&lang=js&"
import style0 from "./Word.vue?vue&type=style&index=0&id=f3303484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3303484",
  null
  
)

component.options.__file = "Word.vue"
export default component.exports